import SectionMessage from "@atlaskit/section-message";

export const ManifestErrorMessage = ({ id }: { id: string }) => {
    return (
        <>
            {id.length === 0 ? null : (
                <SectionMessage appearance="error" isDismissible={true}>
                    <p>
                        <strong>Manifest entry not found for:</strong>{" "}
                        <code>{id}</code>. Rendering control slot.
                    </p>
                </SectionMessage>
            )}
        </>
    );
};
